import { useLanguageStore } from '@/stores/language'

/**
 * Maps our internal locale codes to standard BCP 47 language tags
 * used by Intl.DateTimeFormat and other browser APIs
 */
const LOCALE_MAP: Record<string, string> = {
  enUs: 'en-US',
  ptBr: 'pt-BR',
  esEs: 'es-ES',
  frFr: 'fr-FR',
  deDe: 'de-DE',
  itIt: 'it-IT',
}

/**
 * Hook to get the current locale in BCP 47 format
 * @returns The current locale (e.g., 'pt-BR', 'en-US')
 */
export function useLocale() {
  const { locale } = useLanguageStore()
  return LOCALE_MAP[locale] || LOCALE_MAP.ptBr
}
